export enum EmailStatus {
  Unknown = 0,
  Queued = 1,
  Sent = 2,
  Resent = 3,
  Failed = 4
}
